import Record from "@/models/Record";
import Chart from "@/models/Chart";
import { BestRecordData } from "@/common/types/BestRecordData";
import { Version, VERSION_STRING } from "@/common/types/Version";

export default class BestRecord extends Record {
  readonly scoreDate: Date | null;
  readonly scoreVersion: Version | null;
  readonly missCountDate: Date | null;
  readonly missCountVersion: Version | null;
  readonly clearTypeDate: Date | null;
  readonly clearTypeVersion: Version | null;

  constructor(chart: Chart, data: BestRecordData) {
    super(chart, data as BestRecordData);
    this.scoreDate = data.scoreDate;
    this.scoreVersion = data.scoreVersion;
    this.missCountDate = data.missCountDate;
    this.missCountVersion = data.missCountVersion;
    this.clearTypeDate = data.clearTypeDate;
    this.clearTypeVersion = data.clearTypeVersion;
  }

  get scoreDateString(): string {
    return this.scoreDate !== null ? this.scoreDate.string() : "-";
  }

  get scoreVersionString(): string {
    return this.scoreVersion !== null ? VERSION_STRING[this.scoreVersion] : "-";
  }

  get missCountDateString(): string {
    return this.missCountDate !== null ? this.missCountDate.string() : "-";
  }

  get missCountVersionString(): string {
    return this.missCountVersion !== null ? VERSION_STRING[this.missCountVersion] : "-";
  }

  get clearTypeDateString(): string {
    return this.clearTypeDate !== null ? this.clearTypeDate.string() : "-";
  }

  get clearTypeVersionString(): string {
    return this.clearTypeVersion !== null ? VERSION_STRING[this.clearTypeVersion] : "-";
  }
}
